export const GET_CART_COUPONS = "GET_CART_COUPONS";
export const GET_CART_COUPON_BY_ID = "GET_CART_COUPON_BY_ID";
export const UPDATE_CART_COUPON = "UPDATE_CART_COUPON";
export const DELETE_CART_COUPON = "DELETE_CART_COUPON";
export const CREATE_CART_COUPON = "CREATE_CART_COUPON";
